var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-header",class:{ 'step-header--strong': _vm.strong }},[_c('h2',{staticClass:"step-header__heading",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('small',{staticClass:"step-header__step"},[_vm._v("Krok "+_vm._s(_vm.step)+"/"+_vm._s(_vm.stepCount))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6743063a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepHeader.vue
// module id = null
// module chunks = 